import { Controller, SwitchController, TextAreaController } from '@organisms';
import { Col, Flex, Form, Row, Typography } from 'antd';
import { Control, Controller as ControllerHookForm } from 'react-hook-form';

import { InputColor } from 'src/app/framework/atoms/InputColor/InputColor.atom';
import { InputTag } from 'src/app/framework/atoms/InputTag/InputTag.atom';
import { UploadImage } from 'src/features/Funnel/Components/UploadImage';

interface FormPhysicProductProps {
  control: Control<any>;
  physicProductPrimaryColor: string;
}

export const FormPhysicProduct = ({
  control,
  physicProductPrimaryColor,
}: FormPhysicProductProps) => {
  return (
    <Flex vertical style={{ width: '100%', gap: '24px' }}>
      <Row style={{ width: '100%', gap: '24px' }}>
        <Col style={{ flex: 1 }}>
          <Controller
            control={control}
            showCount={true}
            name={`physicProduct.seo.title`}
            defaultValue={''}
            placeholder='Digite o título aqui'
            autoComplete='off'
            label='Título'
            required
          />
        </Col>
        <Col>
          <Form.Item label='Cor do produto' required>
            <ControllerHookForm
              control={control}
              name={`physicProduct.primaryColor`}
              render={({ field }) => {
                return (
                  <InputColor
                    defaultValue={physicProductPrimaryColor}
                    onValueChange={value => field.onChange(value)}
                    onBlur={field.onBlur}
                  />
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row style={{ width: '100%', gap: '24px' }}>
        <Col style={{ flex: 1 }}>
          <TextAreaController
            control={control}
            name='physicProduct.seo.smallDescription'
            placeholder='Área de texto'
            autoComplete='off'
            label='Descrição curta'
            isMaxLength={true}
            row={3}
            required
            maxLength={160}
          />
        </Col>
        <Col style={{ flex: 1 }}>
          <TextAreaController
            control={control}
            name='physicProduct.seo.largeDescription'
            placeholder='Área de texto'
            autoComplete='off'
            label='Descrição longa'
            isMaxLength={true}
            row={3}
            required
            maxLength={190}
          />
        </Col>
      </Row>
      <Row style={{ width: '100%', gap: '24px' }}>
        <Col style={{ flex: 1 }}>
          <UploadImage
            style={{ width: '100%' }}
            tooltip={{
              title: () => (
                <Typography.Text>
                  Imagem do produto a ser exibida nas redes sociais (google, ig,
                  twitter, etc..)
                </Typography.Text>
              ),
            }}
            includeResourceBaseUrl
            control={control}
            name={`physicProduct.seo.image`}
            label='Imagem'
            required
          />
        </Col>
        <Col
          style={{
            flex: 1,
          }}
        >
          <UploadImage
            style={{ width: '100%' }}
            tooltip={{
              title: () => (
                <Typography.Text>
                  Ícone da página de checkout do produto
                </Typography.Text>
              ),
            }}
            includeResourceBaseUrl
            control={control}
            name={`physicProduct.seo.favicon`}
            label='Fav Icon'
            required
          />
        </Col>
      </Row>
      <Col style={{ width: '100%' }}>
        <Controller
          control={control}
          showCount={true}
          name={`physicProduct.seo.siteName`}
          defaultValue={''}
          placeholder='Digite o nome aqui'
          autoComplete='off'
          label='Nome do site'
          required
        />
      </Col>
      <Col style={{ width: '100%' }}>
        <Controller
          control={control}
          showCount={true}
          name={`physicProduct.footerText`}
          defaultValue={''}
          placeholder='Digite o texto aqui'
          autoComplete='off'
          label='Texto do Rodapé'
          required
        />
      </Col>
      <Col style={{ width: '100%' }}>
        <Form.Item
          label='Palavras-chave'
          required
          tooltip={{
            title: () => (
              <Typography.Text>
                Digite a palavra-chave e tecle enter para confirmar.
              </Typography.Text>
            ),
          }}
        >
          <ControllerHookForm
            control={control}
            name={`physicProduct.seo.keywords`}
            render={({ field }) => {
              return (
                <InputTag
                  placeHolder='Insira as palavras-chave'
                  onChange={value => field.onChange(value)}
                  defaultValue={field.value}
                />
              );
            }}
          />
        </Form.Item>
      </Col>
      <Row
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          gap: '24px',
        }}
      >
        <Col>
          <SwitchController
            control={control}
            defaultValue={false}
            leftLabel='Frete grátis'
            name='physicProduct.isFreeShipping'
            sideLabel
          />
        </Col>
      </Row>
    </Flex>
  );
};
